/**
 * 判断内外网环境
 */

function domainJudge(){
  const href = window.location.href;
  let domain = "outerNet";
  const localReg = /localhost|127.0.0.1?/;
  if(localReg.test(href)){
    domain = 'local'
    return domain
  }

  const intranetReg = /192.168.6.31|192.168.6.32|192.168.20.|http:?\/\/192.168.6.32|k12china-local?/;
  // intranetReg.test(href) && (domain = 'intrane');
  if(intranetReg.test(href)){
    domain = 'intrane'
    return domain
  }

  const outerNetReg = /yondor.cn|k12china?/;
  outerNetReg.test(href) && (domain = 'outerNet');
  if(outerNetReg.test(href)){
    domain = 'outerNet'
    return domain
  }
}
let env = domainJudge();
function loginEnv () {
  let objurl = {
    local: 'http://192.168.6.32:32390/apps/login/v3',
    intrane: 'http://192.168.6.32:32390/apps/login/v3',
    // outerNet: 'https://login.k12china.com/v3'
    outerNet: 'https://yondor.cn/apps/login/v3'
  }
  return objurl[env];
}

function baseWorkEnv () {
  let objurl = {
    local: '/apps/base-work',
    intrane: '/apps/base-work',
    outerNet: '/apps/base-work'
  }
  return objurl[env];
}

function baseWork4JavaEnv () {
  let objurl = {
    local: '/intrane/manger/work',
    intrane: 'http://w.k12china-local.com/manger/work',
    outerNet: 'https://w.k12china.com/manger/work'
  }
  return objurl[env];
}


export const loginDomain = loginEnv()
export const bwDomain = baseWorkEnv()
export const baseWork4JavaDomain = baseWork4JavaEnv()